import React from "react";
export default ({
  styles = {},
  ...props
}) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}><path d="M13.728 8A2.272 2.272 0 1116 10.272 2.27 2.27 0 0113.728 8M16 13.728A2.272 2.272 0 1018.272 16 2.27 2.27 0 0016 13.728m0 8A2.272 2.272 0 1018.272 24 2.27 2.27 0 0016 21.728" /></svg>;